import merge from 'lodash/merge.js';

import BaseGradingScheme from '@/store/modules/base/BaseGradingScheme.js';

export default merge(BaseGradingScheme, {
    autoImport: false,
});
